// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c110518b","517":"e53ccb2e","659":"a1618cae","701":"a5df2652"}[chunkId] + ".chunk.js";
};